import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../global/modal/withModal';
import Button from '../../global/Button';
import { PURCHASE_IDENTITY_NAV_MODAL } from '../../../constants/modals';
import ContextualString from '../../contextual/ContextualString';
import { getAsset } from '../../../util/assets';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  addNewIdentity: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  identities: PropTypes.array,
  onComplete: PropTypes.func.isRequired,
};

const AlbumFolderIdentityNavModal = ({
  albumFolder,
  addNewIdentity,
  closeModal,
  identities = [],
  onComplete,
}) => {
  return (
    <div className="d-flex flex-column justify-content-center">
      <div className="text-center mt-3 mb-2">
        <img
          src={getAsset('/waldo-icon.svg')}
          alt="Waldo logo"
          width="60"
          className="mb-2"
        />

        <h3>Where to go next?</h3>
      </div>
      {identities.length > 1 ? (
        <Button
          btnBlock
          btnStyle="yellow"
          className="mb-2"
          onClick={() => {
            closeModal(PURCHASE_IDENTITY_NAV_MODAL);
          }}
        >
          <ContextualString
            id="consumerSelectOtherIdentity"
            subtype={albumFolder.album_subtype}
            defaultMessage="Add another family member"
          />
        </Button>
      ) : (
        <Button
          btnBlock
          btnStyle="yellow"
          className="mb-2"
          onClick={() => {
            closeModal(PURCHASE_IDENTITY_NAV_MODAL);
            addNewIdentity();
          }}
        >
          <ContextualString
            id="consumerAddNewIdentity"
            subtype={albumFolder.album_subtype}
            defaultMessage="Add new face"
          />
        </Button>
      )}

      <Button
        btnBlock
        onClick={() => {
          closeModal(PURCHASE_IDENTITY_NAV_MODAL);
          onComplete();
        }}
      >
        Continue
      </Button>
    </div>
  );
};

AlbumFolderIdentityNavModal.propTypes = propTypes;

export default withModal(AlbumFolderIdentityNavModal, {
  name: PURCHASE_IDENTITY_NAV_MODAL,
  hideHeader: true,
  size: 'sm',
  type: 'full',
});
